(function($){

    var $controller  = {

        init: function() {
            this.listen();
        },
        
        listen: function() {
           
            /**
             *  Set all external links to open in a new window.
             * 
             *  setTimeout so it doesn't block.
             */
            setTimeout(function() {
                $('a[href^="http"]').each(function() {
                    if(this.href.indexOf(window.location.hostname) === -1) {
                        var $this = $(this);
                        $this
                            .attr('target', '_blank')
                                .attr('rel', $this.attr('rel')+' external');
                    }
                });
            });

        }

    };

    $controller.init();

})(jQuery);


// WEBPACK FOOTER //
// ./tbo/js/listen/externalize-links.js